import React, {useState} from 'react';
import { StyledMobileMenuWrap } from './StyledMobileMenuWrap';
import MenuIndustries from '../MenuIndustries';
import MenuSolutions from '../MenuSolutions';

const MobileMenuWrap = ({ toggle, toggleFn, handleLoad}) => {
  const [showMobileIndustries, setShowMobileIndustries] = useState(false);
  const [showMobileSolutions, setShowMobileSolutions] = useState(false);

  return (
    <React.Fragment > 
      <StyledMobileMenuWrap className={toggle ? 'show hide-desktop' : 'hide-desktop'}>
        
        <div className="hide-mobile">

          <MenuIndustries toggle={toggle} toggleFn={toggleFn} />
          <p className="single--link commerce-route" onClick={() => {handleLoad("/3d-e-commerce"); toggleFn(false)}}>
              <span>
                3D e-commerce
              </span>
          </p>
          <p className="single--link shelfzone-route" onClick={() => {handleLoad("/shelfzone"); toggleFn(false)}}>
              <span>
                Shelfzone
              </span>
          </p>
          <p className="single--link virtual-route" onClick={() => {handleLoad("/virtual-showroom"); toggleFn(false)}}>
              <span>
                Virtual Showroom
              </span>
          </p>
          <p className="single--link full-reality-route" onClick={() => {handleLoad("/full-reality"); toggleFn(false)}}>
              <span>
                Full Reality
              </span>
          </p>
          <p className="single--link news-route" onClick={() => {handleLoad("/news"); toggleFn(false)}}>
              <span>
               News & Events 
              </span>
          </p>
        </div>
        <div className="show-mobile mobile--slider-wrap">
          
          <div className="mobile--slider-main">
            <p className="single--link commerce-route" onClick={() => {handleLoad("/3d-e-commerce"); toggleFn(false)}}>
              <span>
                3D e-commerce
              </span>
          </p>
            <p className="single--link shelfzone-route" onClick={() => {handleLoad("/shelfzone"); toggleFn(false)}}>
                <span>
                  Shelfzone
                </span>
            </p>
            <p className="single--link industries-route" onClick={() => setShowMobileIndustries(!showMobileIndustries)}>Industries</p>

            <p className="single--link virtual-route" onClick={() => {handleLoad("/virtual-showroom"); toggleFn(false)}}>
              <span>
                Virtual Showroom
              </span>
          </p>
            <p className="single--link full-reality-route" onClick={() => {handleLoad("/full-reality"); toggleFn(false)}}>
              <span>
                Full Reality
              </span>
            </p>
            <p className="single--link news-route" onClick={() => {handleLoad("/news"); toggleFn(false)}}>
              <span>
                News & Events
              </span>
            </p>
          </div>
          <div className={showMobileIndustries ? "show mobile--slider-second" : "mobile--slider-second"}>
            <div className="cta--primary back-cta" onClick={() => setShowMobileIndustries(!showMobileIndustries)}>
              <img className="prev" src={require("../../assets/cta-arrow-prev-green.svg")} />
              <p className="base primary-green">Industries</p>
            </div>
            <MenuIndustries toggle={toggle} toggleFn={toggleFn}/>
          </div>

          <div className="rounded--cta" onClick={() => {handleLoad("/book-a-demo"); toggleFn(false)}}>
            <p>Ask for a demo</p>
          </div>
        </div>
        
      </StyledMobileMenuWrap>
    </React.Fragment>
  );
};


export default MobileMenuWrap;
